import { Logout as LogoutIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useServerTranslation } from 'hooks/useServerTranslation';
import useCustomerActions from '../../../hooks/useCustomerActions';
import { HeaderActionButton, HeaderActionButtonProps } from './HeaderActionButton';

type LogoutButtonProps = HeaderActionButtonProps;

export function LogoutButton(props: LogoutButtonProps) {
    const { t } = useServerTranslation();
    const { clickLogOut } = useCustomerActions();

    return (
        <HeaderActionButton
            onClick={clickLogOut}
            {...props}
        >
            <Tooltip title={t('menu.log-out')}>
                <LogoutIcon />
            </Tooltip>
        </HeaderActionButton>
    );
}
